export default __webpack_public_path__ + "static/media/art-2-community.e737d6a5.jpg";